module.exports = __webpack_public_path__ + "0c862409a6292ef0b6bc7ac42e36f24e.MP3";